import clsx from 'clsx';

const sizes = { sm: 'h-4 w-4', md: 'h-8 w-8', lg: 'h-12 w-12' };

export default function Spinner({ size = 'md', className }) {
  return (
    <div
      className={clsx(
        'animate-spin rounded-full border-2 border-neutral-200 border-t-primary-600',
        sizes[size],
        className
      )}
    />
  );
}
